import {httpClient, httpClientRegion} from './';
// 模型上传
export const _uploadRegionModel = modelMeta => {
  return httpClientRegion
    .post(`test/platform/api/models/add`, modelMeta)
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getAllRegionModels = () => {
  return httpClientRegion.get(`test/platform/api/models/list`).then(res => {
    console.log(res);
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _imageUploadForRegion = ({image_list, source, canteen_id}) => {
  return httpClientRegion
    .post(`test/platform/api/upload/img/detect/region`, {
      dish_img_data: image_list,
      canteen_id
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getAllRegionLabelTask = () => {
  return httpClientRegion
    .get(`test/platform/api/label/task/id/list`)
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getRegionImages = () => {
  return httpClient.get(`test_get_region_info`).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _regionImageRandomGetByTaskId = label_task_id => {
  return httpClientRegion
    .post(`test/platform/api/get/photo/by/label`, {label_task_id})
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _regionModelChheckByLabelTask = ({
                                                label_task_id,
                                                detected_region,
                                                region_model_id
                                              }) => {
  return httpClientRegion
    .post(`/region_models/check`, {
      label_task_id,
      detected_region,
      region_model_id
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
// 人工修改图框
export const _fixRegions = ({id, regions, mark_user_name}) => {
  return httpClientRegion
    .post(`test/platform/api/mark/photo/by/people`, {
      id,
      regions,
      mark_user_name
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
// 获取检测的图片
export const _getDetectedImageList = (label_task_id, model_uuid) => {
  return httpClientRegion
    .post(`test/platform/api/img/by/model/lable/list`, {
      label_task_id,
      model_uuid
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
// label_task_id 获取模型信息
export const _getDetectedModelInfo = label_task_id => {
  return httpClientRegion
    .post(`test/platform/api/models/by/label/list`, {label_task_id})
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
// 模型预标注或者检测
export const _regionModelPreMark = ({
                                      label_task_id,
                                      model_uuid,
                                      detect_regions
                                    }) => {
  return httpClientRegion
    .post(`test/platform/api/mark/by/standard/model`, {
      label_task_id,
      model_uuid,
      detect_regions
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
// 获取所有批次
export const _getAllTaskList = () => {
  return httpClientRegion.get(`test/platform/api/detect/task/list`).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
// 预标注
// export const _getRecordDetail = ({ }) => {
//   return httpClient.post(``,
//       {}, {
//       headers: {

//         'api-key': apiKey
//       }
//     }).then(res => {
//     if (res.data.state_code === 0) {
//       return Promise.resolve(res.data.data);
//     } else {
//       return Promise.reject(new Error(`${res.data.error_msg}`));
//     }
//   }).catch(handleError);
// };
export const _uploadimageFromBatch = ({
                                        label_task_uuid,
                                        label_task_day_ts,
                                        canteen_id,
                                        source
                                      }) => {
  return httpClient
    .post(
      `test/platform/api/upload/img/collect/detect/region/new`,
      {
        label_task_uuid,
        label_task_day_ts,
        canteen_id,
        source
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};

export const _getPreMarkTaskDetails = (task_id) => {
  return httpClientRegion.post(`test/platform/api/img/by/task/id`,
    {task_id}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else if (res.data.state_code === -2) {
      return Promise.reject(new Error('-2'));
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getRegionCheckData = (task_id) => {
  return httpClientRegion.post(`test/platform/api/detect/task/retrieve`,
    {task_id}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else if (res.data.state_code === -2) {
      return Promise.reject(new Error(`-2`));
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _regionCheck = ({model_uuid, label_task_id}) => {
  return httpClientRegion.post(`test/platform/api/test/by/standard/model`,
    {model_uuid, label_task_id}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _regionFixDone = (label_task_id, username) => {
  return httpClientRegion.post(`test/platform/api/mark/label/add`,
    {label_task_id, username}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _setStandard = (model_uuid) => {
  return httpClientRegion.post(`test/platform/api/standard/models/upd`,
    {model_uuid}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getDetailByLabelTaskId = (label_task_id, user_name) => {
  return httpClientRegion.post('test/platform/api/img/by/label/retrieve',
    {label_task_id, user_name}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else if (res.data.state_code === -2) {
      return Promise.reject(new Error('-2'));
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _emitZipTask = (zip_task_desc, label_task_ids) => {
  return httpClientRegion.post('test/platform/api/create/xml/add',
    {zip_task_desc, label_task_ids}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getAllZipTask = () => {
  return httpClientRegion.get('/test/platform/api/xml/task/list').then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _regionModelPublish = (model_uuid, canteen_id_list = []) => {
  return httpClientRegion.post(`detection_model/publish`,
      {
        model_uuid,
        canteen_id_list
      }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _regionLabelCancelCheck = (label_task_id) => {
  return httpClientRegion.post(`test/platform/api/img/by/label/cancel`,
      {label_task_id}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _sendLabelTaskList = (label_task_info_list) => {
  return httpClient.post(`test/platform/api/upload/img/collect/detect/region/list`,
      {
        label_task_info_list
      }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getReasonCount = (batch_uuid_list) => {
  return httpClientRegion.post('error_reason_count/by_batch_list',
      {batch_uuid_list}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _deleteImage = (img_id) => {
  return httpClientRegion.post(`img_delete/by_check`,
      {img_id}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getAllCategoryList = () => {
  return httpClientRegion.get(`test/platform/api/category/query`,
      {}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _addCategory = (category_list) => {
  return httpClientRegion.post(`test/platform/api/category/add`,
      {category_list}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getCategoryCount = () => {
  return httpClientRegion.get('/test/platform/api/category/count').then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _updateCategoryTarget = (category_list) => {
  return httpClientRegion.post(`/test/platform/api/category/target_update`,
      {category_list}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _generateZip = (category, zip_task_desc) => {
  return httpClientRegion.post(`/test/platform/api/category/zip_task`, {category, zip_task_desc}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(true);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _setCommonRegionModel = (model_uuid) => {
  return httpClientRegion.post(`test/platform/api/models/common/update`,
      {model_uuid}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getZipTaskProgress = (task_id) => {
  return httpClientRegion.post(`test/platform/api/task/get_task_progress`,
      {task_id}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
